<template functional>
  <section class="about-us-companies flex flex-column locked">
    <div class="about-us-companies__text mb7 pb1 px4" data-aos="fade-left">
      <h3 class="pr4">Sell for the best companies in&nbsp;the world</h3>
      <p>
        The best sales teams in&nbsp;the world hire from Bravado. We&nbsp;vet every employer to&nbsp;ensure they have
        strong product-market fit, achievable quotas, high OTEs, and senior leadership.
      </p>
    </div>

    <div class="about-us-companies__logos relative">
      <div class="about-us-companies__row flex justify-end locked" data-aos="fade-right">
        <img
          src="~@/components/partials/landings/about-us/images/logos/rewatch-logo.svg"
          width="115"
          height="30"
          loading="lazy"
          alt="Rewatch logo"
          class="about-us-companies__logo about-us-companies__logo--rewatch"
        />
        <img
          src="~@/components/partials/landings/about-us/images/logos/metadata-logo.svg"
          width="115"
          height="30"
          loading="lazy"
          alt="Metadata logo"
          class="about-us-companies__logo about-us-companies__logo--metadata"
        />
        <img
          src="~@/components/partials/landings/about-us/images/logos/webflow-logo.svg"
          width="115"
          height="30"
          loading="lazy"
          alt="Webflow logo"
          class="about-us-companies__logo about-us-companies__logo--webflow"
        />
      </div>
      <div class="about-us-companies__row flex justify-end locked" data-aos="fade-right">
        <img
          src="~@/components/partials/landings/about-us/images/logos/ripplematch-logo.svg"
          width="115"
          height="30"
          loading="lazy"
          alt="Ripplematch logo"
          class="about-us-companies__logo about-us-companies__logo--ripplematch"
        />
        <img
          src="~@/components/partials/landings/about-us/images/logos/smartsheet-logo.svg"
          width="115"
          height="30"
          loading="lazy"
          alt="Smartsheet logo"
          class="about-us-companies__logo about-us-companies__logo--smartsheet"
        />
        <img
          src="~@/components/partials/landings/about-us/images/logos/lattice-logo.svg"
          width="115"
          height="30"
          loading="lazy"
          alt="Lattice logo"
          class="about-us-companies__logo about-us-companies__logo--lattice"
        />
      </div>
      <div class="about-us-companies__row flex justify-end locked" data-aos="fade-right">
        <img
          src="~@/components/partials/landings/about-us/images/logos/skan-ai-logo.svg"
          width="115"
          height="30"
          loading="lazy"
          alt="Skan logo"
          class="about-us-companies__logo about-us-companies__logo--skan"
        />
        <img
          src="~@/components/partials/landings/about-us/images/logos/scratchpad-logo.svg"
          width="115"
          height="30"
          loading="lazy"
          alt="Scratchpad logo"
          class="about-us-companies__logo about-us-companies__logo--scratchpad"
        />
        <img
          src="~@/components/partials/landings/about-us/images/logos/vanta-logo.svg"
          width="115"
          height="30"
          loading="lazy"
          alt="Vanta logo"
          class="about-us-companies__logo about-us-companies__logo--vanta"
        />
        <img
          src="~@/components/partials/landings/about-us/images/logos/commsor-logo.svg"
          width="115"
          height="30"
          loading="lazy"
          alt="Commsor logo"
          class="about-us-companies__logo about-us-companies__logo--commsor"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutUsCompanies',
  functional: true,
};
</script>

<style lang="scss" scoped>
.about-us-companies {
  padding: 55px 0 65px;

  @include mq('md') {
    padding: 50px 0 105px;
    flex-direction: row;
  }

  &__logos {
    @include mq('md') {
      width: 50%;
      padding-right: 26px;
      order: 1;

      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(to right, var(--color-text) 5%, transparent 95%);
      }
    }
  }

  &__row {
    flex-wrap: nowrap;
    padding: 8px 0;

    &:nth-child(2n + 2) {
      padding-right: 40px;

      @include mq('md') {
        padding-right: 90px;
      }
    }

    @include mq('md') {
      padding: 16px 0;
    }
  }

  &__logo {
    display: flex;
    background: no-repeat center center var(--theme-color-card);
    background-size: 80px 30px;
    border-radius: 8px;
    height: 36px;
    width: 112px;
    min-width: 110px;
    margin: 0 8px;
    padding: 5px;

    @include mq('md') {
      border-radius: 15px;
      height: 63px;
      width: 183px;
      min-width: 183px;
      margin: 0 18px;
      background-size: 137px 34px;
      padding: 15px;
    }

    &--smartsheet {
      @include mq('md') {
        width: 205px;
        min-width: 205px;
      }
    }

    &--commsor {
      padding: 10px;

      @include mq('md') {
        padding: 20px;
      }
    }

    &--webflow {
      background-size: 64px 20px;
      padding: 10px;

      @include mq('md') {
        width: 161px;
        min-width: 161px;
        padding: 20px;
        background-size: 95px 22px;
      }
    }

    &--vanta {
      background-size: 48px;
      padding: 10px;
      //width: 98px;
      //min-width: 98px;

      @include mq('md') {
        background-size: 76px 23px;
        padding: 20px;
        //width: 140px;
        //min-width: 140px;
      }
    }
  }

  &__text {
    @include mq('md') {
      width: 50%;
      padding: 0 0 0 75px;
      order: 2;
      margin: 0;
    }

    h3 {
      font-weight: 600;
      background: linear-gradient(91.71deg, var(--white) 3.55%, #e8e8e8 95.85%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      //background-clip: text;
      //text-fill-color: transparent;

      margin: 0 0 16px;
      max-width: 420px;
      font-size: 22px;
      line-height: 28px;
      letter-spacing: -0.5px;

      @include mq('md') {
        font-size: 33px;
        line-height: 40px;
        letter-spacing: -1px;
        margin: 12px 0 22px;
        padding: 0;
      }
    }

    p {
      font-weight: 400;
      font-size: 15px;
      line-height: 24px;
      color: var(--gray-20);
      max-width: 470px;

      @include mq('md') {
        font-size: 20px;
        line-height: 32px;
      }
    }
  }
}
</style>
